import Layout from '@app-studio-web/ui/components/Layout'
import * as Sentry from '@sentry/react'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

type ButtonOption = {
  text: React.ReactNode | string
  value: string
}

export default function QuestionOverwhelmPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const [clickedValue, setClickedValue] = useState<string | null>(null)

  const heading = t('pages.onboarding.overwhelm.heading')
  const buttons: ButtonOption[] = useMemo(
    () => [
      { text: t('pages.onboarding.overwhelm.option1'), value: 'rarely' },
      { text: t('pages.onboarding.overwhelm.option2'), value: 'sometimes' },
      { text: t('pages.onboarding.overwhelm.option3'), value: 'often' },
      { text: t('pages.onboarding.overwhelm.option4'), value: 'daily' },
    ],
    [t],
  )

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = 'answer'
    hiddenInput.value = clickedValue || ''
    event.currentTarget.appendChild(hiddenInput)

    if (clickedValue) {
      try {
        sessionStorage.setItem('onboarding_overwhelm', clickedValue)
      } catch (error) {
        Sentry.captureException(error)
      }
    }

    submit(event.currentTarget)
    event.currentTarget.removeChild(hiddenInput)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col">
        <div className="mt-11 shrink-0 text-center">
          <h1 className="custom-heading mb-4" data-testid="label-header">
            {heading}
          </h1>
        </div>

        <div className="flex grow items-end justify-center pb-10">
          <Form
            method="post"
            className="w-full max-w-md"
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col space-y-3">
              {buttons.map((button, index) => (
                <button
                  key={`button-${index}`}
                  type="submit"
                  className={`w-full cursor-pointer rounded-[20px] border bg-white px-6 py-5 text-center text-base transition-all hover:shadow-md ${
                    clickedValue === button.value
                      ? 'border-2 border-blue-400 bg-blue-50'
                      : 'border-gray-200'
                  }`}
                  data-testid={`button-option-${index + 1}`}
                  onClick={() => setClickedValue(button.value)}
                >
                  <p className="font-semibold">{button.text}</p>
                </button>
              ))}
            </div>
          </Form>
        </div>
      </div>
    </Layout>
  )
}
